import { Application } from '@/types/application';
import { Metadata } from '@/types/metadata/metadata';
import { MigrationReport } from '@/types/migration';
import { TableSection } from '@/types/table';
import { APPLICATION_FORMAT } from '../application';
import { updateToFormat2 } from './format2';
import { updateToFormat3 } from './format3';
import { updateToFormat4 } from './format4';
import { updateToFormat5 } from './format5';
import { emptyReport, toTableSections } from './report';

const REPORT_TITLE = 'This application was migrated to the current format';

export const migrateApplication = (
  application: any,
  metadata: Metadata,
  showTable: (title: string, sections: TableSection[]) => void
): Application => {
  const report = emptyReport();
  const migrated = migrate(application, metadata, report);

  if (migrated.format !== APPLICATION_FORMAT) {
    throw new Error(
      `This application is format ${migrated.format}, and this Block Engine Builder reads applications up to format ${APPLICATION_FORMAT}.`
    );
  }

  const sections = toTableSections(report);
  if (sections.length) {
    showTable(REPORT_TITLE, sections);
  }

  return migrated;
};

const migrate = (application: any, metadata: Metadata, report: MigrationReport): Application => {
  if (application.format === 1) {
    return migrate(updateToFormat2(application, report), metadata, report);
  } else if (application.format === 2) {
    return migrate(updateToFormat3(application, report), metadata, report);
  } else if (application.format === 3) {
    return migrate(updateToFormat4(application, metadata, report), metadata, report);
  } else if (application.format === 4) {
    return migrate(updateToFormat5(application, metadata, report), metadata, report);
  }

  return application;
};
